import { typeCreatorV2 } from '../../../redux/utils/common';

//  [REDUCER][TYPE]
export const SET_PAYMENT_LIST: string = typeCreatorV2(
  'PaymentListReducer',
  'SetPaymentsList'
);

export const PAYMENT_INFO: string = typeCreatorV2(
  'PaymentListReducer',
  'PaymentInfo'
);

export const SET_PAYMENT_INFO_LIST: string = typeCreatorV2(
  'PaymentListReducer',
  'SetPaymentInfo'
);

export const UPDATE_PAYMENT_INFO_REFERENCE: string = typeCreatorV2(
  'PaymentListReducer',
  'UpdatePaymentInfoReference'
);
